module.exports = __webpack_public_path__ + "static/media/background-rockharz.f7d22953.jpg";